import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedDock } from 'contracts/Docks';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_DOCKS_',
  }
);

export interface ListDocksState {
  data: ListedDock[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListDocksRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedDock[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListDocksState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListDocksState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListDocksState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListDocksState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListDocksState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listDocks = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListDocksTypes = Types;
export const ListDocksActions = Creators;
